import React from 'react';
import { isEmpty } from 'lodash';
import Button from '../layouts/Button';
import { startEndDateToString, timeToString } from '../../helpers/handleDates';

export default function EventCard({ data }) {
  const { title, startDate, endDate, description, registerLink, subtitle } = data;
  const emptyDate = '0001-01-01T00:00:00Z';
  const noDate = startDate === emptyDate || endDate === emptyDate;
  const currentDate = new Date();
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  const juneDate = '2023-06-03T00:00:00Z';
  const constantData = (startDate && endDate) === juneDate;
  const emptyStringDate = (startDate && endDate) === emptyDate;
  return (
    <div
      className={`bg-white flex lg:flex-row lg:flex-wrap flex-col lg:pt-[50px] pt-[30px]
      lg:pb-[60px] pb-[40px] 4xl:px-[200px] 2xl:px-[100px] lg:px-[50px] px-[25px]
      gap-x-[64px] gap-y-[25px] 2xl:flex-nowrap ${
        startDateObj < currentDate && endDateObj < currentDate ? 'hidden' : ''
      }${constantData ? '!block' : ''}`}>
      <div
        className="flex flex-col lg:gap-y-[10px] gap-y-[5px] w-full lg:w-[calc(30%-32px)]
        shrink-0">
        {title && (
          <h3
            className="text-black 3xl:text-xl text-[20px] leading-9 font-roboto-condensed-bold
            uppercase">
            {title}
          </h3>
        )}
        {subtitle && <h4 className="font-bold text-base w-full">{subtitle}</h4>}
        {noDate || (
          <p
            className="text-black 3xl:text-base text-[15px] leading-6 uppercase
              font-roboto-bold">
            {startEndDateToString(startDate, endDate)}
          </p>
        )}
        <p
          className="text-black 3xl:text-base text-[15px] leading-6 uppercase
              font-roboto-bold">
          {timeToString(startDate) === '12:00AM' ? '' : `${timeToString(startDate)}`}
          {timeToString(endDate) === '12:00AM' ? '' : ` - ${timeToString(endDate)}`}
        </p>
      </div>
      {!description || (
        <p
          className="3xl:text-base text-[15px] leading-6 font-roboto-regular text-black w-full
          lg:w-[calc(70%-32px)] 2xl:w-auto 2xl:grow">
          {description}
        </p>
      )}
      {isEmpty(registerLink) || (
        <div
          className="flex flex-wrap lg:flex-col gap-x-[20px] gap-y-[12px] lg:min-w-[170px]
          lg:pl-[calc(30%+32px)] 2xl:pl-0">
          <Button
            url={registerLink.url}
            ariaLabel={registerLink.name}
            target={registerLink.target}
            label={registerLink.name}
            tagName="register-now"
            variant="primaryRed"
            text="whitespace-pre"
            w="!w-[150px] md:!w-[170px]"
            h="!h-[42px]"
          />
        </div>
      )}
    </div>
  );
}